import React, { useEffect, useState } from "react";
import { getRequest } from "../../service";
import { getEmployeeId } from "../../utils/localStorage";
import { formatDate } from "../../utils/dateTime";
import { Spin, Pagination, Tag } from "antd";

const RequestTable = () => {
  const heading = ["Req Type", "Date", "Status"];
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [current, setCurrent] = useState(1);
  const pageSize = 3;

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        
        const employeeId = getEmployeeId();
        const [shiftRes, leaveRes] = await Promise.all([
          getRequest(`/api/requestshift?employeeId=${employeeId}`),
          employeeId ? getRequest(`/api/leaveRequest?employeeId=${employeeId}`) : Promise.resolve({ leaveRequests: [] })
        ]);
        const shiftRequests = (shiftRes?.requestShifts || []).map(item => ({
          reqType: "Missing Attendance",
          date: item.createdAt,
          status: item.status,
          _id: item._id || item.createdAt // fallback for key
        }));
        const leaveRequests = (leaveRes?.leaveRequests || []).map(item => ({
          reqType: "Leave",
          date: item.createdAt,
          status: item.status,
          _id: item._id || item.createdAt // fallback for key
        }));
        setData([...shiftRequests, ...leaveRequests]);
      } catch (err) {
        setData([]);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Helper to get Tag color and style based on status
  const getStatusTag = (status) => {
    const normalized = (status || "").toLowerCase();
    if (normalized === "pending") {
      return (
        <Tag
          color="#fff7e6"
          style={{
            color: "#faad14",
            borderColor: "#ffe58f",
            background: "#fff7e6",
            fontWeight: 500,
            fontSize: 12,
            padding: "2px 10px",
            borderRadius: 6,
            borderWidth: 1,
            borderStyle: "solid",
            display: "inline-block",
            minWidth: 60,
            textAlign: "center",
          }}
        >
          Pending
        </Tag>
      );
    }
    if (normalized === "approved") {
      return (
        <Tag
          color="#f6ffed"
          style={{
            color: "#52c41a",
            borderColor: "#b7eb8f",
            background: "#f6ffed",
            fontWeight: 500,
            fontSize: 14,
            padding: "2px 12px",
            borderRadius: 6,
            borderWidth: 1,
            borderStyle: "solid",
            display: "inline-block",
            minWidth: 60,
            textAlign: "center",
          }}
        >
          Approved
        </Tag>
      );
    }
    if (normalized === "rejected") {
      return (
        <Tag
          color="#fff1f0"
          style={{
            color: "#ff4d4f",
            borderColor: "#ffa39e",
            background: "#fff1f0",
            fontWeight: 500,
            fontSize: 10,
            padding: "1px 12px",
            borderRadius: 6,
            borderWidth: 1,
            borderStyle: "solid",
            display: "inline-block",
            minWidth: 60,
            textAlign: "center",
          }}
        >
          Rejected
        </Tag>
      );
    }
    // Default
    return (
      <Tag
        style={{
          color: "#595959",
          borderColor: "#d9d9d9",
          background: "#fafafa",
          fontWeight: 500,
          fontSize: 14,
          padding: "2px 12px",
          borderRadius: 6,
          borderWidth: 1,
          borderStyle: "solid",
          display: "inline-block",
          minWidth: 60,
          textAlign: "center",
        }}
      >
        {status}
      </Tag>
    );
  };

  // Pagination logic
  const startIdx = (current - 1) * pageSize;
  const endIdx = startIdx + pageSize;
  const pageData = data.slice(startIdx, endIdx);

  return (
    <Spin spinning={loading} size="large">
      <div className="w-full overflow-x-auto">
        <table className="min-w-[600px] w-full bg-white ">
          <thead>
            <tr className="text-left border-b border-gray-200">
              {heading.map((item) => (
                <th
                  className="px-2 py-2 md:px-4 md:py-2 text-[13px] md:text-[14px] font-semibold text-primary whitespace-nowrap"
                  key={item}
                >
                  {item}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {pageData.length === 0 ? (
              <tr>
                <td colSpan={heading.length} className="px-2 py-4 md:px-4 text-center text-gray-500">
                  No requests found.
                </td>
              </tr>
            ) : (
              pageData.map((item) => (
                <tr className="border-b border-gray-200" key={item._id}>
                  <td className="px-2 py-2 md:px-4 md:py-1 text-[13px] md:text-[14px] text-gray-700 whitespace-nowrap">{item.reqType}</td>
                  <td className="px-2 py-2 md:px-4 md:py-1 text-[13px] md:text-[14px] text-gray-700 whitespace-nowrap">{formatDate(item.date)}</td>
                  <td className="px-2 py-2 md:px-4 md:py-1 text-[13px] md:text-[14px] text-gray-700 whitespace-nowrap">
                    {getStatusTag(item.status)}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      <div className="flex justify-end w-full mt-2">
        <Pagination
          current={current}
          pageSize={pageSize}
          total={data.length}
          onChange={setCurrent}
          showSizeChanger={false}
          className="!w-auto"
        />
      </div>
    </Spin>
  );
};

export default RequestTable;
